import React from 'react';
import Button from 'components/control/button';
import styles from './style.module.scss';
import Link from 'next/link';
import ImageLoader from 'components/image-loader';
import Cookies from 'js-cookie';
import { QUEBEC_POPUP, LOCATION_EXPIRE_DAYS } from 'constants/cookies';
import { GTM_CLICK_QUEBEC_POPUP_AREA_CLOSE, GTM_CLICK_QUEBEC_POPUP_AREA_LEAVE,
  GTM_CLICK_QUEBEC_POPUP_AREA_STAY, GTM_CLICK_QUEBEC_POPUP_HOME_CLOSE,
  GTM_CLICK_QUEBEC_POPUP_HOME_LEAVE, GTM_CLICK_QUEBEC_POPUP_HOME_STAY,
  GTM_CLICK_QUEBEC_POPUP_MAP_CLOSE, GTM_CLICK_QUEBEC_POPUP_MAP_LEAVE,
  GTM_CLICK_QUEBEC_POPUP_MAP_STAY } from 'constants/events';
import { trackEvent } from 'utils/google-tag-manager';
import { withEventTracking } from 'utils/track-event-hof';
import { ModalProps } from 'contexts/modal';

export const HomePageSource = 'homepage';
export const AreaPageSource = 'area';
export const MapPageSource = 'map';
export type QuebecPopupSource = typeof HomePageSource | typeof AreaPageSource | typeof MapPageSource;
export interface QuebecPopupOptions {
  source: QuebecPopupSource;
}

export default function ModalDialogQuebec({ options: { source }, closeModal }: ModalProps<QuebecPopupOptions>) {
  const trackingEvents = getQuebecTrackingEvents(source);

  Cookies.set(QUEBEC_POPUP, 'true', { expires: LOCATION_EXPIRE_DAYS });

  const stayClick = withEventTracking(trackingEvents.stay, closeModal);

  return (
    <div className={styles.component}>
      <div className={styles.header}>
        <ImageLoader src="/next/assets/images/empty-saved-search-exp.svg"/>
        <h5>
          Inscriptions au Québec
          <br/>
          Quebec Listings
        </h5>
        <p>Nous avons d'autres inscriptions au Québec sur notre site Web dédié au Québec, expquebec.com.</p>
        <p>We have more Quebec listings on our dedicated Quebec website expquebec.com</p>
      </div>
      <div className={styles.footer}>
        <Link href="https://expquebec.com/" target='_blank'>
          <Button label="Site Web du Québec / Quebec site" theme="primary" onClick={() => trackEvent(trackingEvents.leave)} />
        </Link>
        <Button label="Rester ici / Stay here" theme="secondary" onClick={stayClick} className={styles.stay} />
      </div>
    </div>
  );
}

export const getQuebecTrackingEvents = (source: QuebecPopupSource) => {
  switch (source) {
  case 'area':
    return {
      stay: GTM_CLICK_QUEBEC_POPUP_AREA_STAY,
      leave: GTM_CLICK_QUEBEC_POPUP_AREA_LEAVE,
      close: GTM_CLICK_QUEBEC_POPUP_AREA_CLOSE,
    };
  case 'map':
    return {
      stay: GTM_CLICK_QUEBEC_POPUP_MAP_STAY,
      leave: GTM_CLICK_QUEBEC_POPUP_MAP_LEAVE,
      close: GTM_CLICK_QUEBEC_POPUP_MAP_CLOSE,
    };
  default:
    return {
      stay: GTM_CLICK_QUEBEC_POPUP_HOME_STAY,
      leave: GTM_CLICK_QUEBEC_POPUP_HOME_LEAVE,
      close: GTM_CLICK_QUEBEC_POPUP_HOME_CLOSE,
    };
  }
};
